/**
 * Membership type — distinguishes the kind of organization in the membership.
 * Serialized as a single letter to minimize Firebase token size.
 */
export enum MembershipType {
  Provider = 'p',   // Drone Service Provider organization
  Farmer = 'f',     // Farmer organization
}
